module.exports = __webpack_public_path__ + "img/1.a674c9ae.png";